import { useStatsigClient } from "@statsig/react-bindings";

/**
 * @hook useIsStatsigLoading
 * @description Hook for checking if the Statsig client is loading. Useful for showing a loading state until the client is ready to prevent
 * showing old state before the client is ready.
 */
const useIsStatsigLoading = () => {
  const { client } = useStatsigClient();
  return client.loadingStatus === "Loading";
};

export default useIsStatsigLoading;
